import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function ArticlesIcon({ className }: IconProps) {
  return (
    <svg
      width="71"
      height="71"
      viewBox="0 0 71 71"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1939)">
        <path
          d="M55.5131 71H2.57389C1.15607 71 0 69.8439 0 68.4261V12.9131C5.03871 7.87435 7.87435 5.03871 12.9131 0H55.5131C56.9309 0 58.0869 1.15607 58.0869 2.57389V68.4043C58.0869 69.8221 56.9309 70.9782 55.5131 70.9782"
          fill="#EAEDF8"
        />
        <path
          d="M50.3431 63.5619H7.74308C6.67426 63.5619 5.80176 62.6894 5.80176 61.6206V19.0424C5.80176 17.9736 6.67426 17.1011 7.74308 17.1011H50.3431C51.4119 17.1011 52.2844 17.9736 52.2844 19.0424V61.6424C52.2844 62.7112 51.4119 63.5837 50.3431 63.5837M7.74308 18.388C7.39408 18.388 7.0887 18.6716 7.0887 19.0424V61.6424C7.0887 61.9914 7.37226 62.2968 7.74308 62.2968H50.3431C50.6921 62.2968 50.9975 62.0132 50.9975 61.6424V19.0424C50.9975 18.6934 50.7139 18.388 50.3431 18.388H7.74308Z"
          fill="#00416B"
        />
        <path
          d="M33.8751 63.5619C33.5261 63.5619 33.2207 63.2783 33.2207 62.9075V17.7555C33.2207 17.4065 33.5043 17.1011 33.8751 17.1011C34.2459 17.1011 34.5295 17.3846 34.5295 17.7555V62.9293C34.5295 63.2783 34.2459 63.5837 33.8751 63.5837"
          fill="#00416B"
        />
        <path
          d="M51.63 24.8444H6.45614C6.10713 24.8444 5.80176 24.5608 5.80176 24.19C5.80176 23.8192 6.08532 23.5356 6.45614 23.5356H51.63C51.979 23.5356 52.2844 23.8192 52.2844 24.19C52.2844 24.5608 52.0008 24.8444 51.63 24.8444Z"
          fill="#00416B"
        />
        <path
          d="M36.4711 13.5456H17.7559C17.4069 13.5456 17.1016 13.262 17.1016 12.8912C17.1016 12.5204 17.3851 12.2368 17.7559 12.2368H36.4711C36.8201 12.2368 37.1255 12.5204 37.1255 12.8912C37.1255 13.262 36.842 13.5456 36.4711 13.5456Z"
          fill="#00416B"
        />
        <path
          d="M51.63 13.5456H40.6583C40.3093 13.5456 40.0039 13.262 40.0039 12.8912C40.0039 12.5204 40.2875 12.2368 40.6583 12.2368H51.63C51.979 12.2368 52.2844 12.5204 52.2844 12.8912C52.2844 13.262 52.0008 13.5456 51.63 13.5456Z"
          fill="#00416B"
        />
        <path
          d="M30.0146 8.72526H17.7559C17.4069 8.72526 17.1016 8.4417 17.1016 8.07088C17.1016 7.70007 17.3851 7.4165 17.7559 7.4165H30.0146C30.3636 7.4165 30.669 7.70007 30.669 8.07088C30.669 8.4417 30.3854 8.72526 30.0146 8.72526Z"
          fill="#00416B"
        />
        <path
          d="M51.63 34.5295H6.45614C6.10713 34.5295 5.80176 34.2459 5.80176 33.8751C5.80176 33.5043 6.08532 33.2207 6.45614 33.2207H51.63C51.979 33.2207 52.2844 33.5043 52.2844 33.8751C52.2844 34.2459 52.0008 34.5295 51.63 34.5295Z"
          fill="#00416B"
        />
        <path
          d="M51.63 44.214H6.45614C6.10713 44.214 5.80176 43.9305 5.80176 43.5596C5.80176 43.1888 6.08532 42.9053 6.45614 42.9053H51.63C51.979 42.9053 52.2844 43.1888 52.2844 43.5596C52.2844 43.9305 52.0008 44.214 51.63 44.214Z"
          fill="#00416B"
        />
        <path
          d="M51.63 53.8991H6.45614C6.10713 53.8991 5.80176 53.6155 5.80176 53.2447C5.80176 52.8739 6.08532 52.5903 6.45614 52.5903H51.63C51.979 52.5903 52.2844 52.8739 52.2844 53.2447C52.2844 53.6155 52.0008 53.8991 51.63 53.8991Z"
          fill="#00416B"
        />
        <path
          d="M67.7063 67.4445C66.8556 67.4445 66.0267 67.1173 65.3724 66.4848L39.6771 40.7895C38.3902 39.5026 38.3902 37.4304 39.6771 36.1434C40.9641 34.8565 43.0363 34.8565 44.3232 36.1434L70.0184 61.8387C71.3054 63.1256 71.3054 65.1978 70.0184 66.4848C69.3859 67.1173 68.5352 67.4445 67.7063 67.4445Z"
          fill="#00416B"
        />
        <path
          d="M63.2564 40.3315C63.2564 51.0197 54.5968 59.7011 43.8868 59.7011C33.1769 59.7011 24.5391 51.0415 24.5391 40.3315C24.5391 29.6215 33.1987 20.9619 43.8868 20.9619C54.575 20.9619 63.2564 29.6215 63.2564 40.3315Z"
          fill="#00C4B3"
        />
        <path
          d="M59.3743 40.3317C59.3743 48.8822 52.4379 55.8186 43.8873 55.8186C35.3368 55.8186 28.4004 48.8822 28.4004 40.3317C28.4004 31.7811 35.3368 24.8447 43.8873 24.8447C52.4379 24.8447 59.3743 31.7811 59.3743 40.3317Z"
          fill="#EAEDF8"
        />
        <path
          d="M57.433 40.3313C57.433 47.813 51.3691 53.8769 43.8874 53.8769C36.4057 53.8769 30.3418 47.813 30.3418 40.3313C30.3418 32.8495 36.4057 26.7856 43.8874 26.7856C51.3691 26.7856 57.433 32.8495 57.433 40.3313Z"
          fill="#FAFBFD"
        />
        <path
          d="M54.8585 40.0044C54.8367 37.1252 53.7024 34.3986 51.6521 32.37C49.5799 30.2978 46.8315 29.1636 43.8868 29.1636C40.9421 29.1636 38.1937 30.2978 36.1215 32.37C34.0493 34.4422 32.915 37.1906 32.915 40.1353C32.915 43.08 34.0493 45.8284 36.1215 47.9006C38.1501 49.9292 40.8112 51.0634 43.6686 51.107H43.8868C46.8097 51.107 49.5799 49.9728 51.6521 47.9006L52.0229 47.5298L50.3433 45.8502L49.9725 46.221C48.3584 47.8352 46.1989 48.7295 43.9086 48.7295C41.6183 48.7295 39.4588 47.8352 37.8229 46.221C36.2087 44.6069 35.3144 42.4474 35.3144 40.1571C35.3144 37.8668 36.2087 35.7074 37.8229 34.0932C39.437 32.4791 41.5965 31.5848 43.9086 31.5848C46.2207 31.5848 48.3584 32.4791 49.9725 34.0932C51.3031 35.4238 52.1537 37.1252 52.3937 38.9792H50.6051C50.3651 37.6051 49.7107 36.3617 48.7074 35.3583C47.4204 34.0714 45.6972 33.3734 43.8868 33.3734C42.0763 33.3734 40.3531 34.0932 39.0662 35.3583C37.7792 36.6453 37.0594 38.3467 37.0594 40.1789C37.0594 42.0112 37.7792 43.7126 39.0662 44.9995C40.3313 46.2646 41.9891 46.9627 43.7777 46.9845H43.8868C45.6972 46.9845 47.4204 46.2647 48.7074 44.9777L49.0782 44.6069L47.3986 42.9273L47.0278 43.2981C46.1989 44.127 45.0865 44.5851 43.8868 44.5851C42.6871 44.5851 41.5965 44.127 40.7458 43.2981C40.2004 42.7528 39.8078 42.0766 39.6115 41.3568H54.8585V40.0699M43.8868 39.0011H39.6115C39.8078 38.2812 40.2004 37.605 40.7458 37.0597C41.5746 36.2309 42.6871 35.751 43.8868 35.751C45.0865 35.751 46.1771 36.209 47.0278 37.0597C47.5731 37.605 47.9657 38.2812 48.162 39.0011H43.8868Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1939">
          <rect width="71" height="71" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
